const GOODS_QUERY_STRING = 'goods'

export default GOODS_QUERY_STRING
